/* Beleaev reusable category-promo engine.

   Edit CONFIG to reuse the same presentation for a future launch.
   Shopify/Appstle remain the owners of selling plans, variant selection, ATC and cart. */
(function () {
  'use strict';
  if (window.__beleaevWagyuLaunchV1) return;
  window.__beleaevWagyuLaunchV1 = true;

  var CONFIG = {
    name: 'Wagyu Introduction',
    offers: [{"discount":20,"cardBadge":"20% Launch Offer","oneTimeBadge":"WAGYU −20%","handles":["beef-grainfed-short-rib-omugi-each-2kg","beef-grainfed-boneless-brisket-omugi-each-5kg","omugi-australian-grain-fed-beef-blade-6kg","omugi-grain-fed-beef-rump-6kg","beef-fillet-grain-fed-omugi-each-2-5kg","beef-ribeye-guide-pricing","beef-ribeye-standard-each-3kg","prime-irish-beef-ribeye-3kg","beef-grainfed-ribeye-omugi-each-4kg","beef-topside-grain-fed-omugi","beef-grainfed-striploin-omugi-each-6kg","japanese-a5-wagyuribeye","japanese-a5-wagyu-sirloin-200g","japanese-a5-wagyu-ribeye-200g","japanese-a5-sirloin-wagyu","japanese-a5-wagyu-chuck-roll-200g","japanese-a5-wagyu-sirloin-2x200g","japanese-a5-wagyu-chuck-roll","japanese-a5-wagyu-fillet","japanese-a5-wagyu-sirloin","japanese-a5-wagyu-ribeye-2x200gg","japanesea5-wagyu-ribeye","japanese-a5-fillet-wagyu","japanese-a5-wagyu-fillet-2x200","japanese-a5-wagyu-sliced-chuck-roll","japanese-a5-wagyu-ribeye","japanese-a5-wagyu-sirloin-bms-10-12-fresh-3kg","japanese-a5-wagyu-fillet-400g"]},{"discount":10,"cardBadge":"10% Launch Offer","oneTimeBadge":"WAGYU −10%","handles":["wagyu-british-beef-bavette-steak-240g","wagyu-british-beef-ribeye-steak-250g-400g","wagyu-british-beef-striploin-steak-250g-400g","wagyu-british-beef-fillet-steaks-150g-x2","wagyu-british-beef-mini-steaks-80g-x4","wagyu-british-beef-bistro-fillet-steaks-200g-x2","wagyu-british-beef-denver-steak-300g","wagyu-british-beef-strips-300g","wagyu-british-beef-alcatra-steak-250g","wagyu-british-beef-flat-iron-steak-240g","wagyu-british-beef-denver-steak-250g","wagyu-british-beef-tomahawk-1-1kg","wagyu-british-beef-whole-flank-bavette-700-x2","wagyu-british-beef-burgers-170g-x2-170g-x6","wagyu-british-beef-bacon-160g","wagyu-british-mince-500g","wagyu-british-beef-whole-fillet-2-4kg","wagyu-british-beef-whole-ribeye-2-4kg","wagyu-british-beef-whole-striploin-3kg","wagyu-british-beef-whole-striploin-6kg","wagyu-british-beef-whole-bavette-daloyau-2kg","wagyu-british-beef-whole-rump-cap-picanha-2-6kg","wagyu-british-whole-beef-tri-tip-1-5kg","wagyu-british-beef-whole-oyster-blade-2-8kg","british-wagyu-beef-shabu-shabu-sukiyaki","wagyu-british-beef-whole-tongue-skin-on","wagyu-british-beef-sliced-bresaola","wagyu-british-beef-sliced-beef-salami-80g","wagyu-british-beef-bresaola","british-beef-ribeye-steak-28-day-dry-aged-250g","british-beef-striploin-steak-28-day-dry-aged-250g","british-beef-fillet-steaks-28-day-dry-aged-150g-x2","british-beef-bone-in-ribeye-28-day-dry-aged-700g","british-beef-picanha-steaks-28-day-dry-aged-200g-x2","british-beef-t-bone-28-day-dry-aged-800g","british-beef-porterhouse-28-day-dry-aged-800g"]}]
  };
  var eligible = Object.create(null);
  CONFIG.offers.forEach(function (offer) {
    offer.handles.forEach(function (handle) { eligible[handle] = offer; });
  });
  window.BeleaevWagyuLaunch = {
    active: true,
    offers: CONFIG.offers.map(function (offer) { return { discount: offer.discount, handles: offer.handles.slice() }; })
  };

  function currency() {
    return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'GBP';
  }

  function money(cents) {
    try {
      return new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: currency()
      }).format(cents / 100);
    } catch (error) {
      return '\u00A3' + (cents / 100).toFixed(2);
    }
  }

  function cardVariants(card) {
    var source = card.getAttribute('data-blv-summer-variants') || '';
    return source.split(',').map(function (pair) {
      var bits = pair.split(':');
      return { id: String(bits[0] || ''), price: Number(bits[1] || 0) };
    }).filter(function (variant) {
      return variant.id && variant.price > 0;
    });
  }

  function excluded(handle) { return handle === "wagyu-grand-cru-cured-beef"; }
  function renderCard(card) {
    if (!card || card.getAttribute('data-blv-wagyu-applied') === 'true') return;
    var handle = card.getAttribute('data-blv-summer-handle') || '';
    var promo = eligible[handle];
    if (!promo || excluded(handle)) return;

    var variants = cardVariants(card);
    if (!variants.length) return;
    var offers = variants.map(function (variant) {
      return {
        was: variant.price,
        now: Math.round(variant.price * (100 - promo.discount) / 100)
      };
    }).sort(function (a, b) { return a.now - b.now; });
    var offer = offers[0];

    var price = card.querySelector('.price');
    if (price && !price.querySelector('.blv-wagyu-card-price')) {
      var customPrice = document.createElement('div');
      customPrice.className = 'blv-wagyu-card-price';
      customPrice.setAttribute('aria-label', promo.discount + '% launch price ' + money(offer.now) + ', was ' + money(offer.was));
      customPrice.innerHTML =
        '<span class="blv-wagyu-card-price__now">' + money(offer.now) + '</span>' +
        '<s class="blv-wagyu-card-price__was">' + money(offer.was) + '</s>';
      price.appendChild(customPrice);

    }

    var isJapanese = /^japanese/.test(handle);
    var imageHost = card.querySelector('.card__media');
    if (imageHost && !imageHost.querySelector('.blv-wagyu-card-badge')) {
      var badge = document.createElement('span');
      badge.className = 'blv-wagyu-card-badge' + (isJapanese ? ' blv-wagyu-card-badge--japanese' : '');
      badge.textContent = promo.cardBadge;
      imageHost.appendChild(badge);
    }
    card.setAttribute('data-blv-wagyu-applied', 'true');
  }

  function parseMoney(text) {
    var value = String(text || '').replace(/[^0-9,.-]/g, '');
    if (!value) return 0;
    var comma = value.lastIndexOf(',');
    var dot = value.lastIndexOf('.');
    if (comma > dot) {
      value = value.replace(/\./g, '').replace(',', '.');
    } else {
      value = value.replace(/,/g, '');
    }
    var amount = Number(value);
    return Number.isFinite(amount) ? Math.round(amount * 100) : 0;
  }

  function productHandle() {
    var json = document.querySelector('product-info script[id^="ProductJson-"]');
    if (json) {
      try { return JSON.parse(json.textContent).handle || ''; } catch (error) {}
    }
    var match = window.location.pathname.match(/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/([^/?#]+)/i);
    return match ? match[1] : '';
  }

  function renderMainPrice(wrapper, was, now, signature, promo) {
    if (!wrapper) return;
    var productInfo = wrapper.closest('product-info,[id^="ProductInfo"]');
    if (!productInfo) return;
    var sourcePrice = productInfo.querySelector('.beleaev-price-bottom');
    if (!sourcePrice) return;
    var oneTimeDetails = wrapper.querySelector('.appstle_one_time_details_wrapper');
    var oneTimeOption = oneTimeDetails ? oneTimeDetails.closest('.appstle_subscription_wrapper_option') : null;
    var oneTimeActive = !!(oneTimeOption && oneTimeOption.classList.contains('appstle-active-option'));
    var line = productInfo.querySelector('.blv-wagyu-main-price');
    if (!line) {
      line = document.createElement('div');
      line.className = 'blv-wagyu-main-price';
      line.hidden = true;
      line.innerHTML =
        '<span class="blv-wagyu-main-price__now"></span>' +
        '<s class="blv-wagyu-main-price__was"></s>' +
        '<span class="blv-wagyu-main-price__badge"></span>';
      sourcePrice.insertAdjacentElement('afterend', line);
    }
    if (line.getAttribute('data-price-signature') !== signature) {
      var nowNode = line.querySelector('.blv-wagyu-main-price__now');
      var wasNode = line.querySelector('.blv-wagyu-main-price__was');
      var badgeNode = line.querySelector('.blv-wagyu-main-price__badge');
      if (nowNode) nowNode.textContent = money(now);
      if (wasNode) wasNode.textContent = money(was);
      if (badgeNode) badgeNode.textContent = promo.oneTimeBadge;
      line.setAttribute('data-price-signature', signature);
      line.setAttribute('aria-label', promo.discount + '% launch price ' + money(now) + ', was ' + money(was));
    }
    sourcePrice.classList.toggle('blv-wagyu-main-price-source-hidden', oneTimeActive);
    line.hidden = !oneTimeActive;
  }
  function renderAppstle() {
    var handle = productHandle();
    var promo = eligible[handle];
    if (!promo || excluded(handle)) return;

    document.querySelectorAll('.appstle_subscription_wrapper').forEach(function (wrapper) {
      var oneTimeText = wrapper.querySelector('.appstle_one_time_text');
      if (oneTimeText && !oneTimeText.parentElement.querySelector('.blv-wagyu-pdp-badge')) {
        var badge = document.createElement('span');
        badge.className = 'blv-wagyu-pdp-badge';
        badge.textContent = promo.oneTimeBadge;
        
        oneTimeText.insertAdjacentElement('afterend', badge);
      }

      var priceWrapper = wrapper.querySelector('.appstle_one_time_price_wrapper');
      if (!priceWrapper) return;
      var source = priceWrapper.querySelector(':scope > .appstle_subscription_amount');
      if (!source) return;
      var was = parseMoney(source.textContent);
      if (!was) return;
      var now = Math.round(was * (100 - promo.discount) / 100);
      var signature = String(was) + ':' + String(now);
      var display = priceWrapper.querySelector('.blv-wagyu-one-time-price');
      if (!display) {
        display = document.createElement('span');
        display.className = 'blv-wagyu-one-time-price';
        display.innerHTML =
          '<span class="blv-wagyu-one-time-price__now"></span>' +
          '<s class="blv-wagyu-one-time-price__was"></s>';
        priceWrapper.appendChild(display);
      }
      if (display.getAttribute('data-price-signature') !== signature) {
        display.querySelector('.blv-wagyu-one-time-price__now').textContent = money(now);
        display.querySelector('.blv-wagyu-one-time-price__was').textContent = money(was);
        display.setAttribute('data-price-signature', signature);
        display.setAttribute('aria-label', promo.discount + '% launch price ' + money(now) + ', was ' + money(was));
      }
      priceWrapper.setAttribute('data-blv-wagyu-price-ready', 'true');
      renderMainPrice(wrapper, was, now, signature, promo);
    });
  }

  function cardHandleFromLink(card) {
    var productLink = card.querySelector('a[href*="/products/"]');
    var match = productLink && (productLink.getAttribute('href') || '').match(/\/products\/([^/?#]+)/i);
    return match ? match[1] : '';
  }

  function renderJapaneseCollectionBadge(card) {
    if (!card || card.querySelector('.blv-wagyu-card-badge')) return;
    var handle = cardHandleFromLink(card);
    var promo = eligible[handle];
    if (!promo) return;
    var isJapanese = /^japanese/.test(handle);
    var imageHost = card.querySelector('.card__media');
    if (!imageHost) return;
    var badge = document.createElement('span');
    badge.className = 'blv-wagyu-card-badge' + (isJapanese ? ' blv-wagyu-card-badge--japanese' : '');
    badge.textContent = promo.cardBadge;
    imageHost.appendChild(badge);
  }

  function scan(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-blv-summer-card]').forEach(renderCard);
    if (scope.matches && scope.matches('[data-blv-summer-card]')) renderCard(scope);
    if (/\/collections\/japanese-a5-wagyu\/?$/.test(window.location.pathname)) {
      scope.querySelectorAll('.card-wrapper').forEach(renderJapaneseCollectionBadge);
    }
    renderAppstle();
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      scan(document);
    });
  }

  function boot() {
    scan(document);
    new MutationObserver(schedule).observe(document.documentElement, {
      childList: true,
      subtree: true,
      characterData: true
    });
    document.addEventListener('change', schedule, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();

/* 2026-09-01 Wagyu announcement visual treatment. */
(function () {
  'use strict';
  var announcementText = 'NEW: The Wagyu Introduction. Enjoy 20% off for a limited time.';

  function enhanceAnnouncement(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.announcement-bar__message > span').forEach(function (message) {
      if (!message || message.getAttribute('data-blv-wagyu-announcement') === 'true') return;
      if ((message.textContent || '').trim() !== announcementText) return;

      var label = document.createElement('span');
      var intro = document.createElement('span');
      var remainder = document.createTextNode(' Enjoy 20% off for a limited time.');
      label.className = 'blv-wagyu-announcement__new';
      label.textContent = 'NEW:';
      intro.className = 'blv-wagyu-announcement__intro';
      intro.textContent = 'The Wagyu Introduction.';

      message.textContent = '';
      message.appendChild(label);
      message.appendChild(document.createTextNode(' '));
      message.appendChild(intro);
      message.appendChild(remainder);
      message.setAttribute('data-blv-wagyu-announcement', 'true');
    });
  }

  function boot() {
    enhanceAnnouncement(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (event) {
    enhanceAnnouncement(event.target);
  });
})();
